import { useEffect, useState } from "react";
import {
  Anchor,
  Avatar,
  Box,
  Container,
  Flex,
  Group,
  Image,
  Text,
} from "@mantine/core";
import classes from "./MerchLogo.module.css";
import { MerchData } from "../../types/types";
import defaultMerchLogo from "../../assets/img/merch.png";
import { useFilterReset } from "../TableSort/FilterGroup/FilterResetContext";

export default function MerchLogo() {
  const [imgsrc, setImgSrc] = useState("");
  const [data, setData] = useState<MerchData>();
  const { resetKey } = useFilterReset();

  useEffect(() => {
    async function getActiveMerch() {
      try {
        const response = await fetch(
          window.location.origin + "/server/client_service/active-merchant"
        );
        const resData = await response.json();
        setData(resData);
        console.log("Res data is", resData);
        setImgSrc(resData.logo_url);
        console.log("url: " + resData.logo_url);
      } catch (error) {
        console.log(error);
      }
    }
    getActiveMerch();
  }, [resetKey]);

  return (
    <Group wrap="nowrap" m="sm">
        <Image
          h={90}
          src={imgsrc}
          alt="merchLogo"
          fallbackSrc={defaultMerchLogo}
        />
      <div>
        <Text fz="xs" tt="uppercase" fw={700} c="dimmed">
          AddPay Payment Gateway
        </Text>

        <Text fz="lg" fw={500} className={classes.name}>
          {data?.name}
        </Text>
      </div>
    </Group>
  );
}
